<template>
  <v-container fluid>
    <v-row>
      <v-col md="4" class="ml-3 mt-3">
        <date-period
          :dense="false"
          :dateType="dateToggle"
          @periodChange="dateChange"
        ></date-period>
      </v-col>
      <v-col md="2" style="text-align: center">
        <v-btn-toggle
          borderless
          class="date_button_navigation"
          v-model="dateToggle"
          :mandatory="mandatory"
        >
          <v-btn height="54" value="DATE">Day</v-btn>
          <v-btn height="54" value="MONTH">Month</v-btn>
          <v-btn height="54" value="YEAR">Year</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col md="1.5">
        <v-autocomplete
          label="Product Type"
          required
          v-model="productTypeIds"
          outlined
          background-color="#fff"
          item-value="id"
          item-text="name"
          :menu-props="{ bottom: true, offsetY: true }"
          :items="productTypes"
          @change="callGraph"
          multiple
        >
          <template
            v-if="productTypeIds.length == productTypes.length"
            v-slot:selection="{ index }"
          >
            <span v-if="index == 0">All</span>
          </template>
          <template v-else v-slot:selection="{ item, index }">
            <span v-if="index == 0">{{ item.name }}</span>
            <span v-if="index == 1">, {{ item.name }}</span>
            <span v-if="index == 2">, ...</span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle('product_types')">
              <v-list-item-action>
                <v-icon
                  :color="productTypeIds.length > 0 ? 'indigo darken-4' : ''"
                  >{{ icon("product_types") }}</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="1.5">
        <v-autocomplete
          label="Service"
          required
          v-model="serviceIds"
          outlined
          background-color="#fff"
          item-value="id"
          item-text="name"
          :menu-props="{ bottom: true, offsetY: true }"
          :items="defaultServices"
          @change="callGraph"
          multiple
        >
          <template
            v-if="serviceIds.length == defaultServices.length"
            v-slot:selection="{ index }"
          >
            <span v-if="index == 0">All</span>
          </template>
          <template v-else v-slot:selection="{ item, index }">
            <span v-if="index == 0">{{ item.name }}</span>
            <span v-if="index == 1">, {{ item.name }}</span>
            <span v-if="index == 2">, ...</span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle('services')">
              <v-list-item-action>
                <v-icon
                  :color="serviceIds.length > 0 ? 'indigo darken-4' : ''"
                  >{{ icon("services") }}</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="1.5">
        <v-autocomplete
          label="Venues"
          required
          v-model="venueIds"
          outlined
          background-color="#fff"
          item-value="id"
          item-text="name"
          :menu-props="{ bottom: true, offsetY: true }"
          :items="venues"
          @change="callGraph"
          multiple
        >
          <template
            v-if="venueIds.length == venues.length"
            v-slot:selection="{ index }"
          >
            <span v-if="index == 0">All</span>
          </template>
          <template v-else v-slot:selection="{ item, index }">
            <span v-if="index == 0">{{ item.name }}</span>
            <span v-if="index == 1">, {{ item.name }}</span>
            <span v-if="index == 2">, ...</span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle('venues')">
              <v-list-item-action>
                <v-icon :color="venueIds.length > 0 ? 'indigo darken-4' : ''">{{
                  icon("venues")
                }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BarChart v-bind="sales"></BarChart>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from "./BarChart";
import moment from "moment";
export default {
  components: {
    BarChart,
  },

  watch: {
    stackType: {
      immediate: true,
      handler() {
        this.callGraph();
      },
    },
    stack(val) {
      this.$emit("stackChange", val);
    },
    reload: {
      immediate: true,
      handler(val) {
        if (val) {
          this.callGraph();
        }
      },
    },
  },
  data() {
    return {
      agePieChart: null,
      genderPieChart: null,
      countryPieChart: null,
      dateToggle: "DATE",
      serviceIds: [],
      productTypeIds: [],
      venueIds: [],
      productIds: [],
      date1: moment().subtract(10, "days").format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      sales: {
        heading: "Qube - Qode Payment Gateway - Total Transactions",
        type: "totalSales",
        fullscreenFlag: true,
        yTitle: "Sales",
        xTitle: "Dates",
        chartData: [],
        loader: true,
        heighest: 0,
      },
      stack: "all",
      mandatory: false,
    };
  },
  mounted() {
    if (this.$store.getters.getDefaultServices.status == false) {
      this.$store.dispatch("loadDefaultServices");
    }
    if (this.$store.getters.getProductTypes.status == false) {
      this.$store.dispatch("loadProductTypes");
    }
    if (this.$store.getters.getVenuesWithQGateway.status == false) {
      this.$store.dispatch("loadVenuesWithQGateway");
    }
    //this.getPaymentTypes();
  },
  computed: {
    defaultServices() {
      return this.$store.getters.getDefaultServices.data;
    },
    productTypes() {
      return this.$store.getters.getProductTypes.data;
    },
    venues() {
      return this.$store.getters.getVenuesWithQGateway.data;
    },
  },
  methods: {
    toggle(type) {
      this.$nextTick(() => {
        if (type == "services") {
          if (this.serviceIds.length == this.defaultServices.length) {
            this.serviceIds = [];
          } else {
            this.serviceIds = this.defaultServices.map((item) => item.id);
          }
        } else if (type == "product_types") {
          if (this.productTypeIds.length == this.productTypes.length) {
            this.productTypeIds = [];
          } else {
            this.productTypeIds = this.productTypes.map((item) => item.id);
          }
        } else if (type == "venues") {
          if (this.venueIds.length == this.venues.length) {
            this.venueIds = [];
          } else {
            this.venueIds = this.venues.map((item) => item.id);
          }
        }
      });
      setTimeout(() => {
        this.callGraph();
      });
    },
    icon(type) {
      if (type == "services") {
        if (this.serviceIds.length == this.defaultServices.length)
          return "mdi-close-box";
        if (this.serviceIds.length == 0) return "mdi-checkbox-blank-outline";
      } else if (type == "product_types") {
        if (this.productTypeIds.length == this.productTypes.length)
          return "mdi-close-box";
        if (this.productTypeIds.length == 0)
          return "mdi-checkbox-blank-outline";
      } else if (type == "venues") {
        if (this.venueIds.length == this.venues.length) return "mdi-close-box";
        if (this.venueIds.length == 0) return "mdi-checkbox-blank-outline";
      }
      return "mdi-minus-box";
    },
    callGraph() {
      this.getOrderSalesGraphData();
    },
    dateChange(data) {
      this.date1 = data.date1;
      this.date2 = data.date2;
      this.callGraph();
    },
    getOrderSalesGraphData() {
      this.sales.loader = true;
      let url = `?mode=${this.dateToggle}&from_date=${this.date1}&to_date=${this.date2}`;
      if (
        this.serviceIds.length > 0 &&
        this.serviceIds != "All" &&
        this.serviceIds != undefined
      ) {
        url += "&service_ids=" + this.serviceIds;
      }
      if (
        this.productTypeIds.length > 0 &&
        this.productTypeIds != "All" &&
        this.productTypeIds != undefined
      ) {
        url += "&product_type_ids=" + this.productTypeIds;
      }
      if (
        this.venueIds.length > 0 &&
        this.venueIds != "All" &&
        this.venueIds != undefined
      ) {
        url += "&venue_ids=" + this.venueIds;
      }
      url += "&wallet_type=online";
      this.$http
        .get(`venues/online-sales${url}`)
        .then((response) => {
          if (response.status == 200) {
            const data = response.data.data;
            let chartData = this.getGraphData(data, "Sales");
            this.sales.heighest = Math.ceil(chartData.largest * 1.1);
            this.sales.chartData = chartData.data;
            this.sales.loader = false;
            this.mandatory = true;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getGraphData(data, type) {
      var graphData = [];
      let largest = 0;
      if (data.length > 0) {
        let keys = Object.keys(data[0]).filter(
          (ele) => ele.toLowerCase() != "date"
        );
        let keysLength = keys.length;
        data.forEach((element, index) => {
          let di = 0;
          let lar = 0;
          for (let i = 0; i <= keysLength; i++) {
            if (index == 0) {
              graphData[i] = {};
              graphData[i].data = {};
              graphData[i].name = keys[i];
              if (element[keys[i]]) {
                lar = lar + parseInt(element[keys[i]]);
              }
              graphData[i].data[element.Date] = element[keys[i]];
              graphData[keysLength] = {};
              graphData[keysLength].name = "Total";
              graphData[keysLength].data = {};
              graphData[keysLength].data[element.Date] = 0;
              di = di + 1;
            } else {
              if (element[keys[i]]) {
                lar = lar + parseInt(element[keys[i]]);
              }
              graphData[i].data[element.Date] = element[keys[i]];
              di = di + 1;
            }
          }
          graphData[keysLength].data[element.Date] = 0;
          if (largest < lar) {
            largest = lar;
          }
        });
        if (keysLength == 1 && keys[0] == type) {
          graphData[0].library = {};
          graphData[0].library.datalabels = {
            color: "rgba(0,0,49)",
            align: "end",
            anchor: "end",
            font: {
              size: 12,
              weight: 700,
            },
          };
        }
        if (this.stackType != "all") {
          graphData[keysLength].library = {};
          graphData[keysLength].library.datalabels = {
            color: function () {
              return "rgba(0,0,49)";
            },
            formatter: (value, ctx) => {
              let total = ctx.chart.$totalizer.totals[ctx.dataIndex];
              if (type == "Bookings") {
                let data = new Intl.NumberFormat("en-US", {
                  maximumSignificantDigits: 4,
                }).format(total);
                return data + (total > 1 ? " bookings" : " booking");
              } else if (type == "Sales") {
                var formatter = new Intl.NumberFormat("en-US", {
                  style: "currency",
                  //currency: this.$store.getters.currencyCode,
                  currency: "AED",
                  minimumFractionDigits: 2,
                });
                return formatter.format(total);
              } else {
                return new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: this.$store.getters.currencyCode,
                  // maximumSignificantDigits: 3,
                }).format(total);
              }
            },
            font: {
              size: 12,
              weight: 700,
            },
            align: "end",
            anchor: "end",
            display: function (ctx) {
              return (
                ctx.datasetIndex === ctx.chart.$totalizer.utmost &&
                ctx.chart.$totalizer.totals[ctx.dataIndex] !== 0
              );
            },
          };
        }
      }
      return { data: graphData, largest: largest };
    },
    calculateRevenue(transaction_amount) {
      return (
        transaction_amount -
        this.getCommission(transaction_amount) -
        this.calculateVAT(this.getCommission(transaction_amount))
      );
    },
    getCommission(amount) {
      return (amount * this.commission.pct) / 100 + this.commission.extra;
    },
    calculateVAT(amount) {
      return (amount * 5) / 100;
    },
  },
};
</script>

<style></style>
